// Bark lines fired above the chibi during combat, chosen by class + action.
// A bark is a short, in-character shout. One-shot, disappears after ~1.6s.
// Keep them varied but flavorful — dark fantasy, terse.

const BY_ACTION = {
  attack: {
    Warrior:  ["For blood!", "You bleed today.", "Cut them down.", "No quarter.", "Face me!"],
    Rogue:    ["Too slow.", "In the dark.", "Shh.", "Right where I want you.", "Dance with me."],
    Guardian: ["Hold the line.", "For the vow.", "Not one step.", "By oath!", "Stand firm."],
    Wizard:   ["Ashes await.", "Old words.", "Wither.", "By the veil.", "Unmake it."],
    Bard:     ["A verse for you.", "Your last chorus.", "Sing it.", "Curtain falls.", "Encore of ruin."],
  },
  ability: {
    Warrior:  ["Break!", "Cleave them!", "Rend!", "Steel bites!", "By the pit!"],
    Rogue:    ["Nightfall.", "Twin fangs.", "Dust to dust.", "Pierce.", "Silent step."],
    Guardian: ["Stand back!", "Shield rise!", "Wall of vow.", "Ward it.", "Hold!"],
    Wizard:   ["Ashen bloom!", "Old rites!", "By the veil!", "Rive!", "Consumed."],
    Bard:     ["Requiem!", "Third verse!", "A dirge sings!", "Coda!", "Silence."],
  },
  magic: {
    Warrior:  ["Reforged rage.", "Blood-magic.", "Burn."],
    Rogue:    ["A whispered curse.", "Vein-drink.", "Hex."],
    Guardian: ["By ward's flame.", "Consecrated.", "Purge!"],
    Wizard:   ["Umbral tide.", "Old words wake.", "Rend the veil.", "Ashen tongue."],
    Bard:     ["Song of ruin.", "A note that kills.", "Break the choir."],
  },
  item: {
    Warrior:  ["Bandage on.", "Not yet.", "Still standing."],
    Rogue:    ["A sip.", "Bite of iron.", "Enough."],
    Guardian: ["Fortify.", "Steady.", "Back in."],
    Wizard:   ["A remedy.", "Restore.", "Focus."],
    Bard:     ["A tavern trick.", "A little drink.", "Renew."],
  },
  hurt: {
    Warrior:  ["Tsch.", "Barely a scratch.", "Try again."],
    Rogue:    ["Cheap shot.", "You'll pay.", "Ah."],
    Guardian: ["Enough of that.", "Hold.", "Not enough."],
    Wizard:   ["Fool.", "Ash marks you.", "You dare?"],
    Bard:     ["A minor key.", "Unpleasant note.", "Off-tempo."],
  },
};

const FALLBACK = ["!", "Hah!", "For the fog!", "By the dark."];

export function pickBark(action, cls) {
  const pool = BY_ACTION[action]?.[cls] || BY_ACTION[action]?.Warrior || FALLBACK;
  return pool[Math.floor(Math.random() * pool.length)];
}
